import { ratingsActions } from '../actions'
import ValidateFormObject, { validates } from '../utils/ValidateFormObject'

const {
  FETCHING_RATING,
  FETCH_RATING,
  FETCH_RATING_ERROR,
  FETCHING_RATINGS,
  FETCH_RATINGS,
  FETCH_RATINGS_ERROR,
  OPEN_MODAL,
  CLOSE_MODAL,
  EDIT_RATING,
  CHANGE_RATING,
  FORM_TOUCHED,
  CHANGE_PAGE,
  CHANGE_PER_PAGE,
  RATING_FORM_ERROR,
  CHANGE_ORDER_COLUMN,
  CHANGE_ORDER_DIRECTION,
  RESET_STATE,
  FETCHING_DETAILS_RATINGS,
  FETCH_DETAILS_RATINGS,
  FETCH_DETAILS_RATINGS_ERROR,
  CHANGE_DETAILS_PAGE,
  CHANGE_DETAILS_PER_PAGE,
  CHANGE_DETAILS_ORDER_COLUMN,
  CHANGE_DETAILS_ORDER_DIRECTION
} = ratingsActions

const initialState = () => ({
  loadingRating: false,
  loadingRatings: false,
  fetchRatingError: false,
  fetchRatingsError: false,
  ratings: [],
  order: {
    column: 'dataUltimaAvaliacao',
    direction: -1
  },
  ratingsPagination: {
    page: 0,
    rowsPerPage: 50,
    length: 0
  },
  rating: {
    status: '',
    idUsuario: '',
    nomeUsuario: '',
    emailUsuario: '',
    conteudo: '',
    tituloConteudo: '',
    nota: ''
  },
  ratingFormErrors: {},
  ratingFormTouched: false,
  modalOpen: false,
  statuses: ['Nova', 'Em revisão', 'Fechada'],
  details: {
    loading: false,
    error: false,
    ratings: [],
    order: {
      column: 'createdAt',
      direction: -1
    },
    ratingsPagination: {
      page: 0,
      rowsPerPage: 50,
      length: 0
    },
    contentTitle: ''
  }
})

const ratingSchema = {
  add: {},
  edit: {}
}

const RatingValidate = new ValidateFormObject(ratingSchema)

const ratings = (state = initialState(), action = {}) => {
  let formSchemaType
  switch (action.type) {
    case CHANGE_RATING:
      formSchemaType = action.rating._id ? 'edit' : 'add'
      return {
        ...state,
        rating: action.rating,
        ratingFormErrors: RatingValidate.validate({
          formObject: action.rating,
          formSchemaType
        })
      }
    case RATING_FORM_ERROR:
      const formErrors = {}
      formSchemaType = state.rating._id ? 'edit' : 'add'
      formErrors[action.field] = { valid: false, errorMessage: action.message }
      return {
        ...state,
        ratingFormErrors: RatingValidate.validate({
          formObject: state.rating,
          invalidFields: formErrors,
          formSchemaType
        })
      }

    case FORM_TOUCHED:
      return {
        ...state,
        ratingFormTouched: true
      }

    case CHANGE_ORDER_COLUMN:
      return {
        ...state,
        order: {
          direction: 1,
          column: action.column
        }
      }

    case CHANGE_DETAILS_ORDER_COLUMN:
      return {
        ...state,
        details: {
          ...state.details,
          order: {
            direction: 1,
            column: action.column
          }
        }
      }

    case CHANGE_ORDER_DIRECTION:
      return {
        ...state,
        order: {
          ...state.order,
          direction: action.direction
        }
      }

    case CHANGE_DETAILS_ORDER_DIRECTION:
      return {
        ...state,
        details: {
          ...state.details,
          order: {
            ...state.details.order,
            direction: action.direction
          }
        }
      }

    case OPEN_MODAL:
      return {
        ...state,
        modalOpen: true
      }
    case CLOSE_MODAL:
      return {
        ...state,
        modalOpen: false
      }

    case CHANGE_PAGE:
      return {
        ...state,
        ratingsPagination: {
          ...state.ratingsPagination,
          page: action.page
        }
      }

    case CHANGE_DETAILS_PAGE:
      return {
        ...state,
        details: {
          ...state.details,
          ratingsPagination: {
            ...state.details.ratingsPagination,
            page: action.page
          }
        }
      }

    case CHANGE_PER_PAGE:
      return {
        ...state,
        ratingsPagination: {
          ...state.ratingsPagination,
          rowsPerPage: action.perPage
        }
      }

    case CHANGE_DETAILS_PER_PAGE:
      return {
        ...state,
        details: {
          ...state.details,
          ratingsPagination: {
            ...state.details.ratingsPagination,
            rowsPerPage: action.perPage
          }
        }
      }

    case FETCH_RATING:
      formSchemaType = (action.rating || {})._id ? 'edit' : 'add'
      return {
        ...state,
        rating: action.rating,
        loadingRating: false,
        fetchratingError: false,
        ratingFormTouched: false,
        ratingFormErrors: RatingValidate.validate({
          formObject: action.rating,
          formSchemaType
        })
      }
    case FETCHING_RATING:
      return {
        ...state,
        loadingRating: true,
        fetchRatingError: false
      }

    case FETCH_RATING_ERROR:
      return {
        ...state,
        loadingRating: false,
        rating: { ...initialState().rating },
        fetchRatingError: action.error
      }
    case FETCH_RATINGS:
      return {
        ...state,
        loadingRatings: false,
        ratings: action.ratings,
        fetchRatingsError: false,
        order: action.order,
        ratingsPagination: {
          length: action.length,
          page: action.page,
          rowsPerPage: action.rowsPerPage
        }
      }
    case EDIT_RATING:
      return {
        ...state,
        details: {
          ...state.details,
          ratings: state.details.ratings.map(rating => {
            if (rating._id === action.rating._id) {
              return action.rating
            }

            return rating
          })
        },
        loadingRatings: false,
        fetchRatingError: false,
        loadingRating: false,
        fetchRatingsError: false
      }
    case FETCHING_RATINGS:
      return {
        ...state,
        loadingRatings: true,
        fetchRatingsError: false
      }
    case FETCH_RATINGS_ERROR:
      return {
        ...state,
        loadingRatings: false,
        fetchRatingError: action.error,
        loadingRating: false
      }

    case RESET_STATE:
      return initialState()

    case FETCHING_DETAILS_RATINGS:
      return {
        ...state,
        details: {
          ...state.details,
          loading: true,
          error: false
        }
      }

    case FETCH_DETAILS_RATINGS:
      return {
        ...state,
        details: {
          ...state.details,
          loading: false,
          error: false,
          ratings: action.ratings,
          order: action.order,
          ratingsPagination: {
            length: action.length,
            page: action.page,
            rowsPerPage: action.rowsPerPage
          },
          contentTitle: action.contentTitle
        }
      }

    case FETCH_DETAILS_RATINGS_ERROR:
      return {
        ...state,
        details: {
          ...state.details,
          loading: false,
          error: action.error
        }
      }

    default:
      return state
  }
}

export default ratings



// WEBPACK FOOTER //
// ./src/reducers/ratings.js